import MarkingList from "../pengecekan-form/MarkingList";
import EditorSectionHeader from "../common/EditorSectionHeader";

/**
 * The photos of the vehicle with their markings (tampak depan, kiri, kanan and belakang) and, when there is a
 * trailer, the photos of the trailer.
 */
const EditorFotoKendaraanSection = ({
  listProblemData,
  headerData,
  permittedToEdit,
  loading,
  folderName,
  pengecekanData,
  pengecekanDetilData,
  handleOnClickReload,
  handleOnClickCameraPreview,
  handleOnClickAddMarking,
  handleOnChangeKordinat,
  handleOnClickRemoveMarking,
  handleOnClickSaveMarkingList,
}) => {
  const hasTrailer = !!(headerData.trailer_id || headerData.data_trailer);

  // one photo card
  const renderMarkingList = ({ title, field }) => (
    <div className="row-start-start w-full flex-wrap gap-4">
      <div className="elevated-card-tight-vertical col-start-center !px-3 !py-3 grow lg:max-w-[32rem]">
        <MarkingList
          listProblemData={listProblemData.filter(
            (el) => el.label_grup === field
          )}
          title={title}
          field={field}
          labelGrup={field}
          headerData={headerData}
          loading={loading}
          disabled={headerData.id && permittedToEdit ? false : true}
          folderName={folderName}
          pengecekanData={pengecekanData}
          pengecekanDetilData={pengecekanDetilData}
          onClickReload={handleOnClickReload}
          onClickCamera={(field) => handleOnClickCameraPreview(field)}
          onClickAddMarking={(field) => handleOnClickAddMarking({ field })}
          onChangeKordinat={(id, marking_kordinat) =>
            handleOnChangeKordinat({ id, marking_kordinat })
          }
          onClickRemove={(data) => handleOnClickRemoveMarking({ data })}
          onClickSave={(labelGrup, detilData) =>
            handleOnClickSaveMarkingList({
              labelGrup,
              pengecekanDetilData: detilData,
            })
          }
        />
      </div>
    </div>
  );

  return (
    <>
      {renderMarkingList({ title: "TAMPAK DEPAN", field: "gambar_depan" })}
      {renderMarkingList({ title: "TAMPAK KIRI", field: "gambar_kiri" })}
      {renderMarkingList({ title: "TAMPAK KANAN", field: "gambar_kanan" })}
      {renderMarkingList({
        title: "TAMPAK BELAKANG",
        field: "gambar_belakang",
      })}

      {hasTrailer && (
        <>
          <EditorSectionHeader title="FOTO TRAILER" />
          {renderMarkingList({
            title: "TAMPAK DEPAN TRAILER",
            field: "gambar_box_depan",
          })}
          {renderMarkingList({
            title: "TAMPAK KIRI TRAILER",
            field: "gambar_box_kiri",
          })}
          {renderMarkingList({
            title: "TAMPAK KANAN TRAILER",
            field: "gambar_box_kanan",
          })}
          {renderMarkingList({
            title: "TAMPAK BELAKANG TRAILER",
            field: "gambar_box_belakang",
          })}
        </>
      )}
    </>
  );
};

export default EditorFotoKendaraanSection;
